import React, { memo } from "react";
import H1 from "../H1";
import H2 from "../H2";

function LowerThird({ cue, baseTheme, baseThemeId }) {
	console.log('Lower third', cue.id)
	return (
		<>
			{/* LARGE TEXT */}
			<H1
				cue={cue}
				text={cue.line_one}
				baseTheme={baseTheme}
				baseThemeId={baseThemeId}
				// whitespace={"whitespace-pre"} // Removed so that the text will wrap and not go offscreen
			/>

			{/* SMALL TEXT */}
			<H2
				cue={cue}
				text={cue.line_two}
				baseTheme={baseTheme}
				baseThemeId={baseThemeId}
				// whitespace={"whitespace-pre"} // Removed so that the text will wrap and not go offscreen
			/>
		</>
	);
}

export default memo(LowerThird, (prevProps, nextProps) => {
  // Compare only the properties that affect rendering
  return (
    prevProps.cue.line_one === nextProps.cue.line_one
		&& prevProps.cue.line_two === nextProps.cue.line_two
		&& prevProps.cue.useCustomImage === nextProps.cue.useCustomImage
		&& prevProps.cue.customImage === nextProps.cue.customImage

		// APPLIES to ALL CUES
		&& prevProps.baseTheme === nextProps.baseTheme
		&& prevProps.baseThemeId === nextProps.baseThemeId
		&& prevProps.cue.theme === nextProps.cue.theme
		&& prevProps.cue.transition === nextProps.cue.transition
		&& prevProps.cue.position === nextProps.cue.position
		&& prevProps.cue.scale === nextProps.cue.scale
		&& prevProps.cue.offsetX === nextProps.cue.offsetX
		&& prevProps.cue.offsetY === nextProps.cue.offsetY
		&& prevProps.cue.rotate === nextProps.cue.rotate
		&& prevProps.cue.crop === nextProps.cue.crop
		&& prevProps.cue.onAirDuration === nextProps.cue.onAirDuration
		&& prevProps.cue.linkedTo === nextProps.cue.linkedTo
		&& prevProps.cue.linkedDelay === nextProps.cue.linkedDelay
		&& prevProps.cue.outputOne === nextProps.cue.outputOne
		&& prevProps.cue.outputTwo === nextProps.cue.outputTwo
		&& prevProps.cue.outputThree === nextProps.cue.outputThree
		&& prevProps.cue.outputFour === nextProps.cue.outputFour
		&& prevProps.cue.outputUtility === nextProps.cue.outputUtility
  )
})